// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1Uzbv","empty":"ModalGraph_empty__3r8SO"};